import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="bg-brand-dark text-white pt-6 pb-2 px-3 md:pt-12 md:pb-4" data-id="element-166">
      <div className="max-w-xl mx-auto text-center" data-id="element-167">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-168">
          {/* Small badge */}
          <div className="inline-block bg-amber-500/20 text-brand-yellow px-4 py-1.5 rounded-full text-xs font-bold mb-4 border border-amber-500/30 tracking-wide" data-id="element-169">
            👩‍🏫 SISTEMA COMPLETO PARA MAESTRAS DE INICIAL, KINDER O JARDÍN
          </div>

          {/* Main headline - larger and bolder */}
          <h1 className="text-[2rem] md:text-5xl lg:text-6xl font-extrabold leading-[1.1] mb-3 px-0" data-id="element-170">
            👉 Todo tu año de Clases de Inicial{' '}
            <span className="bg-gradient-to-r from-amber-400 to-orange-500 bg-clip-text text-transparent" data-id="element-171">
              resuelto...
            </span>
          </h1>

          {/* Subtitle - italic, lighter */}
          <p className="md:text-xl italic mb-4 max-w-md mx-auto text-[12px] text-[#FFDFA8]" data-id="element-172">
            Un sistema claro con clases, actividades y planificación listas para
            usar desde el primer día
          </p>

          {/* Product image */}
          <div className="w-full mb-5 px-2" data-id="element-173">
            <img src="https://cdn.magicpatterns.com/uploads/7EP2fDLDL8ZnaBcRx1B64M/MOCKUP_600X600.png" alt="Megapack Inicial Sin Estrés" className="w-full h-auto drop-shadow-2xl cursor-pointer" width={600} height={600} fetchPriority="high" loading="eager" decoding="async" onClick={() => document.getElementById('oferta')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-174" />
          </div>

          {/* Yellow highlight text */}
          <p className="text-brand-yellow text-base md:text-lg font-medium italic mb-3 max-w-sm mx-auto leading-snug" data-id="element-175">
            Listo para imprimir y usar. Sin improvisar. Sin llegar agotada al
            aula. Sin estrés...
          </p>

          {/* Gray description */}

          {/* Full-width CTA */}
          <CTAButton text="👉 QUIERO MI MEGAPACK AHORA" className="w-auto mx-auto mb-5 py-3 px-6 text-sm md:text-base font-black rounded-xl" data-id="element-176" />

          {/* Trust badges - compact row */}
          <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1.5 text-[11px] md:text-xs text-gray-500" data-id="element-177">
            <div className="flex items-center gap-1" data-id="element-178">
              <ShieldCheck size={14} className="text-brand-yellow" data-id="element-179" />
              <span data-id="element-180">Garantía 7 días sin preguntas</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-181">
              <Lock size={14} className="text-brand-yellow" data-id="element-182" />
              <span data-id="element-183">Pago 100% seguro</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-184">
              <CreditCard size={14} className="text-brand-yellow" data-id="element-185" />
              <span data-id="element-186">Pagas en la moneda de tu país</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}